import React, { useState, useEffect } from 'react';
import { useClient } from '../../context/ClientContext';

export default function ManagerNotes() {
  const { brand, fetcher } = useClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetcher.fetchManagerNotes()
      .then(setData)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (!data?.note) return null;

  const formattedDate = data.updatedAt
    ? new Date(data.updatedAt + 'T00:00:00').toLocaleDateString('en-AU', {
        day: 'numeric', month: 'long', year: 'numeric'
      })
    : null;

  return (
    <div className="rounded-xl border border-gray-100 p-6" style={{ backgroundColor: brand.colors?.accent?.warmNeutral || '#F0F7FC' }}>
      <div className="flex items-center gap-2 mb-3">
        <svg className="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
        </svg>
        <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide"
            style={{ fontFamily: brand.typography?.headerFont }}>
          A note from Beech PPC
        </h3>
      </div>
      <p className="text-gray-700 leading-relaxed">{data.note}</p>
      {formattedDate && (
        <p className="text-xs text-gray-400 mt-3">Last updated: {formattedDate}</p>
      )}
    </div>
  );
}
